import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="bg-[#d9f0ea] py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          
          <h1 className="text-4xl font-bold text-gray-800 mt-1">
            Who We Are
          </h1>
          <p className="text-gray-700 mt-4 max-w-3xl mx-auto">
            We are a trusted distribution and international trading group focused on 
            operational excellence, strong brand partnerships, and scalable supply 
            chain solutions across domestic and global markets.
          </p>
        </motion.div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Our Vision",
              text: `To be a trusted, scalable, and future-ready distribution and international trading group, recognized for operational excellence, strong brand partnerships, and reliable supply chain solutions across domestic and global markets.`,
            },
            {
              title: "Our Mission",
              text: `To deliver efficient and compliant distribution & C&F operations that support brand growth across modern trade and organized retail. 
              To build strong, transparent partnerships with principals, retailers, and international buyers. 
              To expand our merchant export and import capabilities with dependable sourcing, quality products, and timely delivery.`,
            },
            {
              title: "Our Core Values",
              text: `Integrity – We operate with honesty and accountability.
              Reliability – We deliver through disciplined execution.
              Partnership Mindset – We grow through long-term relationships.
              Operational Excellence – We focus on efficiency and continuous improvement.
              Customer & Brand Focus – We prioritize compliance and service quality.
              Growth with Responsibility – We pursue sustainable and ethical business practices.`,
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.2,
                ease: "easeOut",
              }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default About;